<div card-body class="flex justify-content-start gap-5">
    <ng-container *ngFor="let item of data; let index = index">
        <div  (click)="emitEvent(index)">
            <div class="item_border px-3 py-3 w-full" [ngClass]="currentInternalIndex == index? 'selected_item': ''">

                <div class="h-3rem flex align-items-center">

                    <split-icon [name]="item.icon"> </split-icon>

                    <span class="tittle_typography ml-2">
                        {{item.title}}
                    </span>

                </div>

            </div>
        </div>
    </ng-container>
</div>